// @core/stores/task/TaskAnalyticStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { taskApi } from '@core/api';
import type {
  TaskStatsResponse,
} from '@core/types/task';

class TaskAnalyticStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get task statistics
   */
  async GetTaskStats(params?: { period_end?: string | number | boolean; period_start?: string | number | boolean; }): Promise<TaskStatsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await taskApi.GetTaskStats(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const taskAnalyticStore = new TaskAnalyticStore();
